import React from 'react';
import config from '../config';

// The Microsoft four square mark. Inline so it needs no asset and no network.
const MicrosoftLogo = () => (
    <svg width="18" height="18" viewBox="0 0 21 21" aria-hidden="true" style={{ flexShrink: 0 }}>
        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
        <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
        <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
);

// A real navigation, not a fetch: the response is a redirect into a Microsoft
// login session, and only a navigation can follow it.
const MicrosoftSignInButton = () => {
    const startSignIn = () => {
        window.location.href = `${config.hostname}/auth/microsoft/start`;
    };

    return (
        <div className="mt-3">
            <div className="d-flex align-items-center mb-3">
                <hr className="flex-grow-1 m-0" />
                <span className="f-12 f-light px-2">or</span>
                <hr className="flex-grow-1 m-0" />
            </div>
            <button
                type="button"
                onClick={startSignIn}
                className="btn d-flex align-items-center justify-content-center w-100"
                style={{
                    border: '1px solid #d5d8dc',
                    backgroundColor: '#ffffff',
                    color: '#3b4045',
                    fontWeight: 500,
                    gap: '10px'
                }}>
                <MicrosoftLogo />
                Sign in with Microsoft
            </button>
        </div>
    );
};

export default MicrosoftSignInButton;
